import {defineStore} from 'pinia'
import {DraggableElement, PPTDragDropElement} from "@/types/slides.ts";

export const useWidgetStore = defineStore('widgetStore', {
  state: () => ({
    multiSelect: false,
    activeType: 'none',
    activeSubtype: '',
    activeId: '',
    selectedWidget: {} as DraggableElement,
    selectedWidgets: [] as DraggableElement[],
    selectedWidgetGroupId: "" as string,
    selectedSectionId: "" as string,
    selectedSectionRowId: "" as string,
    selectedSubsectionId: "" as string,
    selectedSubsectionRowId: "" as string,
    selectedDragDropId: "" as string,
    selectedTableCell: {},
    textSelected: false,
    inputSelected: false,
    alignment: '',
    selectionFontSize: 14,
    selectionBold: false,
    selectionItalic: false,
    selectionUnderline: false,
    selectionColor: '#000',
    selectionList: false,
    sectionSelected: false,
    subsectionSelected: false,
  }),

  actions: {
    setMultiSelect(multiSelect: boolean) {
      this.$state.multiSelect = multiSelect
    },

    setActiveWidgets(widgets: DraggableElement[]) {
      if (widgets.length === 0) {
        this.$state.activeId = ''
        this.$state.activeType = 'none'
        this.$state.sectionSelected = false
        this.$state.subsectionSelected = false
      }
      if (widgets.length === 1) {
        this.$state.activeId = widgets[0].id
        this.$state.activeType = widgets[0].type
        this.$state.selectedWidget = widgets[0]
      }

      this.$state.selectedWidgets = widgets
    },

    addActiveWidget(widget: DraggableElement) {
      if (this.$state.selectedWidgets.length === 0) {
        this.$state.activeId = widget.id
        this.$state.activeType = widget.type
        this.$state.activeSubtype = widget.subType
        this.$state.selectedWidget = widget
      }

      this.$state.selectedWidgets.push(widget)
    },

    setActiveWidget(widget: DraggableElement, widgetGroupId: string, sectionId: string, sectionRowId: string) {
      this.$state.activeId = widget.id
      this.$state.activeType = widget.type
      this.$state.activeSubtype = widget.subType || null
      this.$state.selectedWidget = widget
      this.$state.selectedWidgets = [widget]
      this.$state.selectedWidgetGroupId = widgetGroupId
      this.$state.selectedSectionId = sectionId
      this.$state.selectedSectionRowId = sectionRowId
    },
    setActiveDragDrop(dragDropId: string) {
      this.$state.selectedDragDropId = dragDropId
    },
  }
})
